export const POST_PINS = 'POST_PINS'
export const GET_PINS_AND_HOOKS = 'GET_PINS_AND_HOOKS'
export const RETURN_MESSAGE = 'RETURN_MESSAGE'
